
import { defineComponent, inject, nextTick, onMounted, ref } from "vue";

import { Question, store, storeKey } from "@/services/Store";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { DefaultBasicUtil, IBasicUtil } from "../interfaces/IBasicUtil";
import question from "@/services/question";
import Comp1 from "../components/questions/Comp1.vue"
import Comp2 from "../components/questions/Comp2.vue"
import Comp3 from "../components/questions/Comp3.vue"
import Comp4 from "../components/questions/Comp4.vue"
import Timer from "../components/parts/Timer.vue";
import TimerGage from "../components/parts/TimerGage.vue";
export default defineComponent({
  name: "Main",
  components: {
    Comp1,
    Comp2,
    Comp3,
    Comp4,
    TimerGage,
    Timer
  },
  data() {
    return {
      question: null as Question | null,
      tabId: 0 as number,
      time: 0 as number,
      buttonDisabled: false as boolean
    }
  },

  setup() {
    const { data, isEnded, allTime } = inject(storeKey) as store;
    const allMinutes = Math.floor(allTime.value / 60)
    const timer = ref<typeof Timer | null>(null);

    const timerStop = () => {
      if (timer.value) {
        timer.value.stop();
      }
    };
    return {
      data,
      isEnded,
      timer,
      timerStop,
      allMinutes,
      basicbasicUtil: inject<IBasicUtil>(DefaultBasicUtil) as IBasicUtil,
    };
  },

  created() {
    const isAuth = this.basicbasicUtil.isAuth("1");
    if (!isAuth) this.$router.push("/auth");
    if (this.data.length == 0) {
      location.href = "/"
      return
    }
    const questions = this.data[Number(this.$route.params.id) - 1]
    this.question = questions
    if (this.question != null) this.tabId = this.question.id


  },

  methods: {
    next() {
      
      if (this.data.length <= (Number(this.$route.params.id))) {
        this.end()
        return
      }
      this.timerStop()
      this.$router.push({ name: "Main", params: { id: Number(this.$route.params.id) + 1 } });
    },

    end() {
      if (!confirm("受検を終了しますか？")) return
      this.overTime()
    },

    overTime() {
      this.timerStop()
      this.$router.push("/result");
    }
  },
});
